import React from 'react'

import { Dialog, DialogContent, IconButton, Typography, Divider, DialogActions, Grid, Button } from '@material-ui/core';
import { mdiClose } from '@mdi/js';
import Icon from '@mdi/react';
import classes from './index.module.scss'

type Props = {
    open: boolean,
    onClose: () => void,
    children: React.ReactNode,
    cancelLabel?: string,
    submitLabel?: string,
    onSubmit: () => void,
    loading: boolean;
}

function ConfirmModal({ open, onClose, children, cancelLabel, submitLabel, onSubmit, loading = false }: Props) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="responsive-dialog-title"
        >
            <DialogContent>
                <div
                    style={{
                        position: 'absolute',
                        left: '17px',
                        zIndex: 10,
                    }}
                >
                    <IconButton aria-label="close" onClick={onClose}>
                        <Icon path={mdiClose} size={1} />
                    </IconButton>
                </div>

                <div className={classes.cancelTitle}>
                    {children}
                </div>
                <Divider style={{ marginBottom: '10px' }} />
            </DialogContent>
            <DialogActions className={classes.actionsBox}>
                <Grid container spacing={2}>
                    <Grid
                        item
                        xs={12}
                        spacing={2}
                        style={{ padding: '5px 0', marginBottom: '8px' }}
                    >
                        <Button
                            style={{ margin: '7px', padding: '5px 30px' }}
                            autoFocus
                            onClick={onClose}
                            variant="outlined"
                            color="primary"
                            size="medium"
                            data-cy="cancel"
                        >
                            {cancelLabel}
                        </Button>
                        <Button
                            style={{ margin: '7px' }}
                            variant="contained"
                            onClick={onSubmit}
                            size="medium"
                            color="primary"
                            data-cy="saveBtn"
                            disabled={loading}
                        >
                            {submitLabel}
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

ConfirmModal.defaultProps = {
    cancelLabel: "انصراف",
    submitLabel: "تایید"
}

export default ConfirmModal;